// extracted by mini-css-extract-plugin
export default {"zoomControlsWrapper":"styles_zoomControlsWrapper__DNdRn","zoomControls":"styles_zoomControls__UMmuu","control":"styles_control__D1q1A"};